(function ($) {
    $(document).ready(function () {
        if ($(window).width() < 961) {
            $(".section-gifting .row-custom").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 4000,
                arrows: true,
                dots: false,
                infinite: true,
            });

            $(".section-third-image-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 4000,
                arrows: true,
                dots: false,
                infinite: true,
            });
        }

        let checkSlick = setInterval(function () {
            if ($('.productView-nav').hasClass('slick-initialized')) {
                $('.productView-nav').slick('slickGoTo', 1);
                clearInterval(checkSlick);
            }
        }, 500);
    });
})(jQuery);
